import { useMutation } from '@tanstack/react-query';
import { API } from 'network/api';

type StakeholderSyncResult = {
  recordId: string;
  failureReason?: string;
  stakeholderType: 'FGL' | 'PB';
};

const useSyncRecords = () => {
  return useMutation({
    mutationFn: async (country: string) => {
      const res = await API.post('/stakeholder/sync', null, {
        params: {
          country,
        },
      });
      return res?.data as StakeholderSyncResult[];
    },
  });
};

export default useSyncRecords;
